@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

@form-padding: @space-16;
@headerAndFooterHeight: 50px;

.form {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: @rate-browser-form--header--background-color;
}

.header {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: @form-padding;
  border-bottom: 1px solid @rate-browser-modal-form--header--border-color;
  height: @headerAndFooterHeight;
  font-size: 18px;
}

.body {
  flex: 1;
  padding: @space-12 @space-16;
  overflow-y: auto;
}

.section {
  width: 100%;
  margin-top: @space-20;
}

.section:first-child {
  margin-top: 0;
}

.section-header {
  margin-bottom: @space-12;
}

.field {
  margin-top: @space-8;
}

.field:first-child {
  margin-top: 0;
}

.field-label {
  margin-bottom: @space-4;
}

.text-input {
  height: 38px;
  font-size: 16px;
}

.footer {
  padding: @form-padding;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  height: @headerAndFooterHeight;
  border-top: 1px solid @rate-browser-modal-form--footer--border-color;
  background-color: @rate-browser-modal-form--footer--background-color;
}

.handling-unit-card {
  border: 1px solid @rate-browser-modal-form--header--border-color;
  border-radius: 4px;
  padding: @space-12;
  margin-top: @space-8;
}

.handling-unit-header {
  justify-content: space-between;
  margin-bottom: @space-12;
}

.dimension-input-compact {
  max-width: 100%;
}

.commodity-card {
  border: 1px solid @rate-browser-modal-form--header--border-color;
  border-radius: 4px;
  padding: @space-12;
  margin-top: @space-8;
}

.commodity-header {
  justify-content: space-between;
  margin-bottom: @space-8;
}

.address-row {
  align-items: flex-end;
}

.address-row > * {
  flex: 1;
}

.services-collapsible-container {
  border: 1px solid @rate-browser-modal-form--header--border-color;
  border-radius: 4px;
  overflow: hidden;
  margin-top: @space-8;
}

.services-collapsible-section {
  border-bottom: 1px solid @rate-browser-modal-form--header--border-color;
}

.services-collapsible-section:last-child {
  border-bottom: none;
}

.services-collapsible-header {
  font-size: 14px;
  font-weight: 500;
  color: var(--default--text-color--18);
  padding: @space-4 0;
}

.services-options-content {
  padding: @space-0 @space-16 @space-16;
}

.services-option {
  font-size: 14px;
  height: auto;
}

.date-picker {
  display: flex;
  width: 100%;
}

.date-picker input {
  height: 38px;
  line-height: 38px;
  width: 100%;
  font-size: 16px;
}

.date-picker button {
  height: 38px;
}

.stackable-checkbox {
  margin-top: @space-8;
  font-size: 14px;
  height: auto;
  white-space: nowrap;
}

.state-dropdown {
  width: 100%;
}

.state-dropdown > div {
  width: 100%;
}

.state-dropdown button {
  width: 100%;
  min-height: 38px;
}

.country-dropdown {
  width: 100%;
}

.country-dropdown > div {
  width: 100%;
}

.country-dropdown button {
  width: 100%;
  min-height: 38px;
}

.ship-from-field {
  margin-top: @space-8;
}

.ship-from-field button {
  min-height: 38px;
}

.commodities-section {
  border-top: 1px solid @rate-browser-modal-form--header--border-color;
  padding-top: @space-12;
  margin-top: @space-12;
}

.commodities-label {
  margin-top: @space-4;
}

.contact-field {
  position: relative;
  margin-top: @space-8;
}
